import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "!text-sm !leading-5 text-foreground" }
const _hoisted_2 = { class: "!text-sm !leading-5 text-muted-foreground" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass([
      'sent-request-card rounded-xl border bg-card text-card-foreground shadow flex items-center justify-between px-6 py-4',
      _ctx.data.state === 'UPDATED' ? 'cursor-pointer' : '',
    ]),
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goToReviewSentRequest && _ctx.goToReviewSentRequest(...args)))
  }, [
    _createElementVNode("p", _hoisted_1, [
      _cache[1] || (_cache[1] = _createElementVNode("span", { class: "font-medium" }, "Partner Name:", -1)),
      _createTextVNode(" " + _toDisplayString(_ctx.data.name), 1)
    ]),
    _createElementVNode("p", _hoisted_2, " Request Sent: " + _toDisplayString(_ctx.formatDate(_ctx.data.created_at)), 1)
  ], 2))
}